@switch (step()) {
  @case ('invitation') {
    <div class="invitation">
      <div class="invitation__header">
        <app-enfaf-icon svgIconName="check-circle-dark" iconSize="56px"></app-enfaf-icon>
      </div>
      <div class="invitation__title">
        <h2>¡Ahora comprobemos lo que has aprendido!</h2>
      </div>
      <div class="invitation__body">
        <p>Pon a prueba lo que has aprendido con este breve cuestionario</p>
      </div>
      <div class="invitation__actions">
        <app-enfaf-button type="modal-outline" (click)="onPostpone()">Hacerlo más tarde</app-enfaf-button>
        <app-enfaf-button type="modal-primary" (click)="onStartQuiz()">Comenzar</app-enfaf-button>
      </div>
    </div>
  }
  @case ('loading') {
    <div class="loading">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Cargando preguntas...</span>
    </div>
  }
  @case ('question') {
    @for (q of [currentQuestion()]; track q.quizQuestionId) {
      <app-quiz-question
        [question]="q"
        [selectedOption]="currentAnswer()"
        [questionNumber]="currentQuestionIndex() + 1"
        [totalQuestions]="totalQuestions()"
        [isSubmitting]="isSubmitting()"
        (answered)="onQuestionAnswered($event)"
        (back)="onGoBack()"
        (close)="onPostpone()"
      ></app-quiz-question>
    }
  }
  @case ('result') {
    @if (result(); as r) {
      <app-quiz-result [result]="r" (action)="onResultAction($event)"></app-quiz-result>
    }
  }
}
